import React from "react";
const PRERENDER_TEXTS = require("../../../../../prerender_base.js");
import './InvestHeader.css';
import InvestMenu from "../InvestMenu/InvestMenu";
import Invest02 from "../../../../static/img/Invest/Invest02.png";
import ChangeLink from "../../../../Elements/ChangeLink/ChangeLink";

function InvestHeader(props) {
    return (
        <header className="InvestHeader">
        <header className="InvestHeaderIn">

            <ChangeLink lang = {props.lang} to={`/invest`}><img alt='Ifyoudontseeimages' src={Invest02} width="218px" height="36px"/></ChangeLink>
            <InvestMenu styleMain='InvestHeaderMenu' active='InvestMenuElementActiveLink' inactive='InvestHeaderActiveLinkNot'
                        Name01={JSON.parse(props.PrerenderTexts['InvestHeader0000'])[props.lang] ? JSON.parse(props.PrerenderTexts['InvestHeader0000'])[props.lang] : '*Fxbitcoin.org' }
                        Name02={JSON.parse(props.PrerenderTexts['InvestHeader0005'])[props.lang] ? JSON.parse(props.PrerenderTexts['InvestHeader0005'])[props.lang] : '*ВОЙТИ НА СЧЕТ' }
                        Name03={JSON.parse(props.PrerenderTexts['InvestHeader0010'])[props.lang] ? JSON.parse(props.PrerenderTexts['InvestHeader0010'])[props.lang] : '*ПЕРЕХОД НА СЛЕД. ЭТАП' }
                        Name04={JSON.parse(props.PrerenderTexts['InvestHeader0015'])[props.lang] ? JSON.parse(props.PrerenderTexts['InvestHeader0015'])[props.lang] : '*FAQ' }
                        Name05={JSON.parse(props.PrerenderTexts['InvestHeader0020'])[props.lang] ? JSON.parse(props.PrerenderTexts['InvestHeader0020'])[props.lang] : '*РЕГИСТРАЦИЯ' }
                        lang={props.lang}
            />

        </header>
        </header>
    )}

export default InvestHeader
